import { PageHeading } from '@/console/ui/PageHeading'
import { TABS } from '@/console/shell/tabs'
import { DefaultPriorityGridPanel } from './DefaultPriorityGridPanel'

const tab = TABS.find((t) => t.key === 'obs')!

/**
 * 출고 설정 탭(LOGISPRD-15812). 운영 요청으로 디폴트 센터 우선순위를 슬롯 단위로 한꺼번에 바꾼다.
 * `onBusyChange` 는 셸의 탭바 잠금으로 이어진다. 응답 전에 탭을 바꾸면 반영 결과를 놓친다.
 */
export const OutboundSettingTab = ({ onBusyChange }: { onBusyChange?: (busy: boolean) => void }): JSX.Element => (
  <>
    <PageHeading title={tab.heading} sub={tab.sub} />
    <DefaultPriorityGridPanel onBusyChange={onBusyChange} />
  </>
)
